import { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import style from "./Termination.module.css";
import TerminateText from "./components/terminate/TerminateText";
import {
  getByAuthService,
  putRequestByAuth,
} from "../../../../function/helper";
import Laoding from "../../../../components/Loading";
import { Spinner } from "react-bootstrap";

function Termination() {
  const naviagate = useNavigate();
  const location = useLocation();

  const [isContractTerminated, setIsContractTerminated] = useState(false);
  const [everBeenAgent, setEverBeenAgent] = useState(true);
  const [isLoading, setIsLoading] = useState([true, false]);

  useEffect(() => {
    if (location.pathname !== "/print-terminate") getData();
    else setIsLoading([false, false]);
  }, []);

  const getData = async () => {
    setIsLoading(cur => {
      cur[0] = true;
      return [...cur];
    });
    const response = await getByAuthService("/agent/v1/is-contract-terminated");
    setIsLoading(cur => {
      cur[0] = false;
      return [...cur];
    });

    if (response.status === 200) {
      setIsContractTerminated(response.data.result);
    } else {
      setEverBeenAgent(false);
    }
  };

  const terminateContract = async () => {
    setIsLoading(cur => {
      cur[1] = true;
      return [...cur];
    });
    const response = await putRequestByAuth("/agent/v1/terminate-contract");
    setIsLoading(cur => {
      cur[1] = false;
      return [...cur];
    });
    if (response.status === 200) {
      Swal.fire({
        icon: "success",
        text: response.data.message,
        confirmButtonText: "پرینت اعلامیه",
        confirmButtonColor: "green",
      }).then(() => {
        naviagate("/print-terminate", { relative: false });
      });
    } else {
      Swal.fire({
        icon: "error",
        text: response.data.message,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "gray",
      });
    }
  };

  const confirmButton = () => {
    if (isContractTerminated === true) {
      naviagate("/print-terminate", { relative: false });
      return;
    }

    Swal.fire({
      icon: "warning",
      text: "آیا از فسخ قرارداد خود مطمئنید ؟",
      confirmButtonText: "بله",
      confirmButtonColor: "red",
      cancelButtonText: "خیر",
      customClass: "rtl-all",
      showCancelButton: true,
    }).then(res => {
      if (res.isConfirmed) {
        terminateContract();
      }
    });
  };

  if (isLoading[0]) {
    return <Laoding />;
  }

  if (!everBeenAgent) {
    return <Fragment></Fragment>;
  }

  return (
    <section
      className={
        "px-1 px-md-4" +
        (location.pathname === "/print-terminate" ? " mt-5" : "")
      }
    >
      <TerminateText />

      <div className="mt-5">
        {location.pathname === "/print-terminate" && (
          <button
            className={
              "header-button blueShadow blueBackground " + style.printButton
            }
            onClick={() =>
              window.print({ paperSize: { width: "21cm", height: "29.7cm" } })
            }
          >
            پرینت
          </button>
        )}
        {location.pathname !== "/print-terminate" && (
          <Fragment>
            {isLoading[1] === true && (
              <button className="header-button blueShadow blueBackground">
                <div className="d-flex align-items-center">
                  <Spinner
                    style={{
                      width: "20px",
                      height: "20px",
                      fontSize: "0.8rem",
                    }}
                  />
                  <span className="me-1"> در حال ثبت</span>
                </div>
              </button>
            )}
            {isLoading[1] === false && (
              <button
                className="header-button blueShadow blueBackground"
                onClick={confirmButton}
              >
                {isContractTerminated ? "پرینت" : "تایید و پرینت"}
              </button>
            )}
          </Fragment>
        )}
      </div>
    </section>
  );
}

export default Termination;
